// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__325QI","empty":"ModalGraph_empty__8W4qV"};